import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Holding page for the Osstre Control Tower. */
@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {}
